<template>
  <section class="why-choose" id="whyChooseUs">
    <h2>
      {{ $t("message.benefits_title") }}
    </h2>

    <p class="subtitle">
      {{ $t("message.benefits_sub_title") }}
    </p>

    <div class="grid">
      <!-- Card 1 -->
      <div class="card">
        <div class="icon">📍</div>
        <h3>{{ $t("message.benefits_title_card1") }}</h3>
        <p>
          {{ $t("message.benefits_description_card1") }}
        </p>
      </div>

      <!-- Card 2 -->
      <div class="card">
        <div class="icon">🛡️</div>
        <h3>{{ $t("message.benefits_title_card2") }}</h3>
        <p>
          {{ $t("message.benefits_description_card2") }}
        </p>
      </div>

      <!-- Card 3 -->
      <div class="card">
        <div class="icon">❤️</div>
        <h3>{{ $t("message.benefits_title_card3") }}</h3>
        <p>
          {{ $t("message.benefits_description_card3") }}
        </p>
      </div>

      <!-- Card 4 -->
      <div class="card">
        <div class="icon">👥</div>
        <h3>{{ $t("message.benefits_title_card4") }}</h3>
        <p>
          {{ $t("message.benefits_description_card4") }}
        </p>
      </div>

      <!-- Card 5 -->
      <div class="card">
        <div class="icon">⭐</div>
        <h3>{{ $t("message.benefits_title_card5") }}</h3>
        <p>
          {{ $t("message.benefits_description_card5") }}
        </p>
      </div>

      <!-- Card 6 -->
      <div class="card">
        <div class="icon">🔄</div>
        <h3>{{ $t("message.benefits_title_card6") }}</h3>
        <p>
          {{ $t("message.benefits_description_card6") }}
        </p>
      </div>
    </div>
  </section>
</template>
<style scoped>
.why-choose {
  padding: 80px 24px;
  text-align: center;
  background: #ffffff;
}

h2 {
  font-size: 40px;
  margin-bottom: 12px;
}

.subtitle {
  max-width: 680px;
  margin: 0 auto 60px;
  font-size: 18px;
  color: #555;
  line-height: 1.6;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
}

.card {
  background: #fff;
  border: 1px solid #e5eaea;
  border-radius: 18px;
  padding: 32px 28px;
  text-align: left;
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
}

.icon {
  width: 48px;
  height: 48px;
  background: #e9f8ee;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 22px;
}

.card h3 {
  font-size: 20px;
  margin-bottom: 10px;
}

.card p {
  font-size: 15px;
  color: #555;
  line-height: 1.6;
}

/* Responsive */
@media (max-width: 900px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  h2 {
    font-size: 30px;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>
